<template>
  <router-link :to="url" class="menu-item" @click.native="$store.commit('setPrevFormsTab', null)">
    <div v-html="svg[svgIcon]" class="header-svg"></div>
    <div>{{ $t(`HEADER.${name}`) }}</div>
  </router-link>
</template>

<script>
import svg from '../../_svg.js'
export default {
  props: {
    name: String,
    url: String,
    iconUrl: String,
    svgIcon: String
  },
  data () {
    return {
      svg: svg
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Header/NavItem.vue